export interface Language {
  key: string;
  name: string;
  label?: string;
}

export enum TranslationLanguage {
  en = "en",
  "en-US" = "en-US",
  "en-CA" = "en-CA",
  "en-AU" = "en-AU",
  "en-GB" = "en-GB",
  "en-SG" = "en-SG",
  "en-IN" = "en-IN",
  "en-AE" = "en-AE",
  es = "es",
  "es-MX" = "es-MX",
  fr = "fr",
  "fr-CA" = "fr-CA",
  pt = "pt",
  ja = "ja",
  ar = "ar",
  "zh-Hans" = "zh-Hans",
  "zh-Hant" = "zh-Hant",
  ko = "ko",
}

export type Translation = {
  [key in TranslationLanguage]?: unknown;
};
